module.exports = __webpack_public_path__ + "static/media/allsvenskan.1ff07558.png";